import { tokenAuthApiInstance } from 'utils/auth';

import { REIGIONS } from '../constants';

export const getReligions = async (): Promise<string[]> => {
  const response = await tokenAuthApiInstance.authAxios().get(REIGIONS);
  return response.data;
};
